'use client';
import React, { useState } from 'react';
import Image from '@components/common/ImageFallback';
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  CalendarOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { getContentsInTopics } from '@root/src/services/client/topic';
import Link from 'next/link';
import { useTranslation } from '@root/src/i18n/client';
const Divider = () => <hr className="border-t border-gray-300 my-4" />;
const TOPIC_CONTENT_PAGE_SIZE = 6;
const TopicContent = ({
  topicParent,
  content,
  currentPage,
  listContentInitial,
  isLastPage,
}) => {
  const { t } = useTranslation('common');
  const [page, setPage] = useState(currentPage);
  const [contents, setContents] = useState(listContentInitial);
  const [_isLastPage, setIsLastPage] = useState(isLastPage);
  const getContent = (slug, page) => {
    getContentsInTopics(
      slug,
      page,
      undefined,
      undefined,
      undefined,
      TOPIC_CONTENT_PAGE_SIZE
    )
      .then(res => {
        if (res.success) {
          setContents(res.data);
          setIsLastPage(page === res.totalPage);
        } else {
          setContents([]);
        }
      })
      .catch(() => {
        setContents([]);
      });
  };
  const fetchNextPage = async () => {
    const nextPage = page + 1;
    getContent(topicParent.slug, nextPage);
    setPage(nextPage);
  };
  const fetchFirstPage = async () => {
    const nextPage = 1;
    getContent(topicParent.slug, nextPage);
    setPage(nextPage);
  };
  const showBackToTop = _isLastPage && page > 1;
  const formatDate = dateStr => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    if (Number.isNaN(date.getTime())) return '';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };
  const getDisplayDate = record => record?.publishedAt || record?.createdAt;
  return (
    <div className="flex flex-col-reverse md:flex-row justify-center">
      <div className="md:w-1/4 w-full md:pr-5 md:mt-3 mt-6">
        <h1 className="text-[18px] font-[600] uppercase text-[#333]">
          {t('topic.featured')}
        </h1>
        <Divider />
        {contents.map(record => (
          <div key={record.id}>
            <div
              className={`relative flex cursor-pointer p-2 ${
                content.slug === record.slug ? 'bg-gray-200' : ''
              }`}
            >
              <Link
                className={'absolute inset-0'}
                href={`/topic/${topicParent.slug}/${record.slug}`}
              ></Link>
              <div>
                <Image
                  width={90}
                  height={60}
                  style={{ objectFit: 'contain' }}
                  src={record?.image?.[0] || topicParent?.image}
                  alt={record?.id}
                />
              </div>
              <div className="ml-2">
                <h2 className="text-[16px] font-[500] line-clamp-2 uppercase hover:text-[#a7252f]">
                  {record.title}
                </h2>
                <div className="text-[#636363] mt-1">
                  <CalendarOutlined className="mr-1" />
                  <span>{formatDate(getDisplayDate(record))}</span>
                </div>
              </div>
            </div>
            <Divider />
          </div>
        ))}
        <Image
          width={200}
          height={120}
          src={topicParent?.image}
          alt={topicParent?.id}
        ></Image>
       {!_isLastPage ? (
          <button onClick={fetchNextPage} className="mt-5">
            {t('topic.loadMore')}
            <span>
              {' '}
              <ArrowRightOutlined />
            </span>
          </button>
        ) : showBackToTop ? (
          <button onClick={fetchFirstPage} className="mt-5">
            <span>
              {' '}
              <ArrowLeftOutlined />
            </span>
            {t('topic.backToTop')}
          </button>
        ) : null}
      </div>
      {!content ? (
        <h1 className="text-[25px] flex justify-center font-[600] uppercase text-[#706f6f] w-full">
          {t('topic.empty')}
        </h1>
      ) : (
        <div className="md:w-3/4 w-full md:pl-5">
          <h1 className="text-[25px] font-[900] uppercase text-[#333]">
            {content?.title}
          </h1>
          <div className="flex">
            <div className="text-[#333]">
              <CalendarOutlined className="mr-1" />
              <span>{formatDate(getDisplayDate(content))}</span>
            </div>
            <div className="text-[#333] ml-5">
              <UserOutlined className="mr-1" />
              <span>{t('topic.postedBy', { author: topicParent?.author || '-' })}</span>
            </div>
          </div>
          <div
            className="text-justify mt-10"
            dangerouslySetInnerHTML={{
              __html: content?.body,
            }}
          />
        </div>
      )}
    </div>
  );
};
export default TopicContent;
